export default {
  // Hero Section
  'hero.badge': 'Asian Alley Mini Mall — Rīga, Latvija',
  'hero.title.line1': 'Āzijas Tirgus',
  'hero.title.line2': 'Asian Alley',
  'hero.description': 'Īrējiet kiosku Āzijas preču tirdzniecībai Rīgas centrā — Nav nepieciešama pieredze, nav nepieciešamas valodu zināšanas, mēs atbalstām visu!',
  'hero.price': 'Tikai no',
  'hero.priceDay': '10 EUR/dienā',
  'hero.priceOr': 'vai',
  'hero.priceMonth': '150 EUR/mēnesī',
  'hero.cta.register': 'Reģistrēties Kioska Īrei Tagad',
  'hero.cta.viewTypes': 'Skatīt Kiosku Veidus',
  'hero.stats.price': 'Īres cena/dienā',
  'hero.stats.size': 'Izmērs no',
  'hero.stats.support': 'Visaptverošs atbalsts',

  // Intro Section
  'intro.badge': 'Risinājums Jums',
  'intro.title.line1': 'Vai Saskaraties ar',
  'intro.title.line2': 'Šīm Grūtībām?',
  'intro.problem1': 'Vēlaties būt pašnodarbināts, bet nezināt, no kurienes sākt?',
  'intro.problem2': 'Nezināt vietējo valodu?',
  'intro.problem3': 'Nezināt, kādi dokumenti nepieciešami?',
  'intro.problem4': 'Nav stabilas biznesa vietas?',
  'intro.solution.title': 'Asian Alley Mini Mall jums palīdzēs!',
  'intro.solution.desc': 'Mēs nodrošinām gatavu biznesa telpu, atbalstu dokumentu kārtošanā, valodu un darbībā — lai jūs varētu koncentrēties tikai uz pārdošanu.',
  'intro.imageCaption': '✨ Asian Alley Mini Mall',
  'intro.imageSubCaption': 'Āzijas preču tirdzniecības centrs — Rīga, Latvija',

  // Product Categories Section
  'categories.badge': 'Biznesa Kategorijas',
  'categories.title.line1': 'Piemērotās',
  'categories.title.line2': 'Preces',
  'categories.subtitle': 'Asian Alley specializējas Āzijas precēs un pakalpojumos — nišas tirgus, kas strauji aug Eiropā',
  'categories.swipeHint': 'Velciet, lai redzētu vairāk',
  'categories.cat1.title': 'Amatniecība',
  'categories.cat1.desc': 'Rokdarbi, gleznas, suvenīri, unikāli tradicionālie Āzijas produkti, kas piesaista tūristus un vietējos iedzīvotājus.',
  'categories.cat1.tag': 'Populārs',
  'categories.cat2.title': 'Apģērbs un Audumi',
  'categories.cat2.desc': 'Āzijas mode, tradicionālie audumi, ao dai, kimono, hanbok un raksturīgie audumi no Vjetnamas, Japānas, Korejas, Ķīnas.',
  'categories.cat2.tag': 'Bestsellers',
  'categories.cat3.title': 'Rotaslietas un Aksesuāri',
  'categories.cat3.desc': 'Aproces, kaklarotas, auskari, matu sprādzes, somas un izsmalcināti Āzijas modes aksesuāri par pieņemamām cenām.',
  'categories.cat3.tag': 'Augsta peļņa',
  'categories.cat4.title': 'Virtuves Piederumi',
  'categories.cat4.desc': 'Māla podi, wok pannas, tējas komplekti, ēdamie irbulīši, keramikas trauki un Āzijas virtuves piederumi, ko mīl eiropieši.',
  'categories.cat4.tag': 'Augsts pieprasījums',
  'categories.cat5.title': 'Pakalpojumi',
  'categories.cat5.desc': 'Matu griešana, galvas mazgāšana, nagu aprūpe, masāža, ādas kopšana Āzijas stilā — pakalpojumi, ko eiropieši ļoti novērtē.',
  'categories.cat5.tag': 'Pakalpojumi',

  // Kiosk Types Section
  'kiosk.badge': 'Īres Cenrādis',
  'kiosk.title': 'Kiosku',
  'kiosk.titleHighlight': 'Veidi',
  'kiosk.subtitle': 'Izmēri no 1.7×2.5m līdz 2.5×2.5m — elastīgi atbilstoši jūsu vajadzībām un budžetam',
  'kiosk.location': 'Atrašanās vieta:',
  'kiosk.locationValue': 'Aspazijas Bulvaris 32, Rīga, Latvija (Pagrabs)',
  'kiosk.hours': 'Darba laiks:',
  'kiosk.hoursValue': '11:00 – 19:00, Pirmdiena – Svētdiena',
  'kiosk.swipeHint': 'Velciet, lai redzētu vairāk',
  'kiosk.mini.name': 'Mini Kiosks',
  'kiosk.mini.size': '1.7 × 2.5 m',
  'kiosk.mini.area': '4.25 m²',
  'kiosk.mini.daily': '10 EUR',
  'kiosk.mini.monthly': '150 EUR',
  'kiosk.mini.badge': 'Visekonomiskākais',
  'kiosk.standard.name': 'Standarta Kiosks',
  'kiosk.standard.size': '2.5 × 2.5 m',
  'kiosk.standard.area': '6.25 m²',
  'kiosk.standard.daily': '25 EUR',
  'kiosk.standard.monthly': '250 EUR',
  'kiosk.standard.badge': 'Vispopulārākais',
  'kiosk.office.name': 'Biroja Telpa Īrei',
  'kiosk.office.size': 'No 20m²',
  'kiosk.office.area': '',
  'kiosk.office.daily': 'Sazināties',
  'kiosk.office.monthly': 'Sazināties',
  'kiosk.office.badge': 'Birojs',
  'kiosk.perDay': '/dienā',
  'kiosk.perMonth': '/mēnesī',
  'kiosk.or': 'vai',
  'kiosk.contact': 'Cenu piedāvājums pēc vajadzībām',
  'kiosk.popularBadge': '⭐ Visvairāk Izvēlēts',
  'kiosk.features.mini': 'Piemērots aksesuāriem, rotaslietām, pakalpojumiem.',
  'kiosk.features.standard': 'Piemērots apģērbam, amatniecībai, virtuves piederumiem',
  'kiosk.features.office': 'Piemērots masāžai, tiešsaistes pārdošanai, konsultācijām',
  'kiosk.feature1': 'Standarta izstādes vitrīna',
  'kiosk.feature2': 'Pamata elektrība un ūdens',
  'kiosk.feature3': 'Bezmaksas Wifi',
  'kiosk.feature4': 'Iekļauta infrastruktūras maksa',
  'kiosk.feature5': 'Privātas telpas dizains',
  'kiosk.feature6': 'Specializēta elektrības un ūdens sistēma',
  'kiosk.feature7': 'Wifi un atbalsta iekārtas',
  'kiosk.feature8': 'Padziļinātas darbības konsultācijas',
  'kiosk.cta': 'Reģistrēt Šo Kiosku',
  'kiosk.promo.badge': '🔥 Ierobežots Piedāvājums',
  'kiosk.promo.period': 'Reģistrējieties no',
  'kiosk.promo.to': 'līdz',
  'kiosk.promo.desc': 'Saņemiet īres atlaidi',
  'kiosk.promo.months': 'aprīlī, maijā, jūnijā',
  'kiosk.promo.discount1': 'Atlaide 30%',
  'kiosk.promo.discount1Type': 'dienā',
  'kiosk.promo.discount2': 'Atlaide 20%',
  'kiosk.promo.discount2Type': 'mēnesī',
  'kiosk.note': '* Cenas neietver 21% PVN. Cenas var mainīties atkarībā no atrašanās vietas un laika. Sazinieties, lai saņemtu precīzāko cenu piedāvājumu.',

  // Add-on Services Section
  'addon.badge': 'Papildu Pakalpojumi',
  'addon.title': 'Biznesa Atbalsta',
  'addon.titleHighlight': 'Paketes',
  'addon.subtitle': 'Papildu pakalpojumu paketes, kas palīdz jums profesionāli, likumīgi un efektīvi vadīt biznesu Latvijā',
  'addon.flipHint': 'Noklikšķiniet uz kartes, lai redzētu paketes detaļas',
  'addon.flipViewFeatures': 'Noklikšķiniet, lai redzētu',
  'addon.flipFeaturesCount': 'funkcijas',
  'addon.starter.name': 'STARTER',
  'addon.starter.subtitle': 'Sākuma Atbalsts',
  'addon.starter.price': '30',
  'addon.starter.badge': 'Jaunpienācējiem',
  'addon.business.name': 'BUSINESS',
  'addon.business.subtitle': 'Profesionāls Bizness',
  'addon.business.price': '60',
  'addon.business.badge': 'Vispopulārākais',
  'addon.premium.name': 'PREMIUM',
  'addon.premium.subtitle': 'Visaptverošs Bizness',
  'addon.premium.price': '100',
  'addon.premium.badge': 'Visaptverošākais',
  'addon.perMonth': 'EUR/mēnesī',
  'addon.popularBadge': '⭐ Visvairāk Izvēlēts',
  'addon.feature.starter1': 'Pašnodarbināta reģistrācijas atbalsts',
  'addon.feature.starter2': 'Bankas konta atvēršanas instrukcijas (Revolut / Wise)',
  'addon.feature.starter3': 'Karšu maksājumu pieņemšanas instrukcijas',
  'addon.feature.starter4': 'Pamata nodokļu konsultācijas',
  'addon.feature.starter5': 'Piemērots iesācējiem',
  'addon.feature.business1': 'Viss no Starter paketes',
  'addon.feature.business2': 'Ikmēneša nodokļu deklarēšanas pakalpojums',
  'addon.feature.business3': 'Atbalsts darbā ar nodokļu iestādēm',
  'addon.feature.business4': 'Produktu reklāma Asian Alley Mini Mall kanālā 3 reizes/mēnesī',
  'addon.feature.premium1': 'Viss no Business paketes',
  'addon.feature.premium2': 'Iknedēļas produktu reklāma',
  'addon.feature.premium3': 'Atbalsts Āzijas preču avotu meklēšanā',
  'addon.feature.premium4': 'SumUp karšu maksājumu savienojums',
  'addon.feature.premium5': 'Produktu reklāma Asian Alley Mini Mall kanālā 10 reizes/mēnesī',
  'addon.feature.premium6': 'Pārdošanas personāla pieņemšana darbā',
  'addon.flipBack': 'Atpakaļ',
  'addon.flipCta': 'Reģistrēt Šo Paketi',
  'addon.extras.title': 'Papildu Izvēles Pakalpojumu Izmaksas',
  'addon.extras.subtitle': 'Individuālie pakalpojumi pēc vajadzībām — atsevišķs cenu piedāvājums',
  'addon.extra1': 'Pašnodarbināta reģistrācija',
  'addon.extra2': 'Vienreizēja nodokļu deklarācija',
  'addon.extra3': 'Facebook reklāma',
  'addon.extra4': 'Kioska dizains',
  'addon.extra5': 'Kioska izkārtne',
  'addon.cta': 'Sazināties par Cenu Piedāvājumu',
  'addon.note': '* Cenas neietver 21% PVN. Sazinieties, lai saņemtu konsultāciju par piemērotāko paketi.',

  // Support Section
  'support.badge': 'Visaptverošs Atbalsts',
  'support.title': 'Mēs Atbalstām',
  'support.titleHighlight': 'Jūs Visā',
  'support.subtitle': 'No dokumentiem, valodas līdz darbībai — Asian Alley pavada jūs no pirmās dienas',
  'support.doc.title': 'Dokumentu Atbalsts',
  'support.doc.desc': 'Mēs vadām un atbalstām visas biznesa reģistrācijas procedūras, darbības atļaujas Latvijā saskaņā ar likumu.',
  'support.lang.title': 'Valodu Atbalsts',
  'support.lang.desc': 'Vjetnamiešu - latviešu - angļu tulku komanda atbalsta komunikāciju ar klientiem un iestādēm.',
  'support.space.title': 'Gatava Telpa',
  'support.space.desc': 'Kiosks ir aprīkots ar pamata iekārtām, pilnu elektrību un ūdeni, ātru wifi — jums tikai jāatnes preces un jāsāk pārdot.',
  'support.community.title': 'Biznesa Kopiena',
  'support.community.desc': 'Pievienojieties Āzijas kiosku īpašnieku kopienai Rīgā — dalieties pieredzē, atbalstiet viens otru un attīstieties kopā.',
  'support.marketing.title': 'Mārketings un Reklāma',
  'support.marketing.desc': 'Asian Alley organizē pasākumus, regulāras akcijas, kas piesaista tūkstošiem apmeklētāju katru mēnesi.',
  'support.security.title': 'Drošība un Aizsardzība',
  'support.security.desc': 'Drošības kameru sistēma 24/7, profesionāla apsardze — jūsu īpašums un preces vienmēr ir pilnībā aizsargāti.',

  // Gallery Section
  'gallery.badge': 'Reālās Fotogrāfijas',
  'gallery.title': 'Asian Alley',
  'gallery.titleHighlight': 'Telpa',
  'gallery.subtitle': 'Izpētiet dzīvo, mājīgo biznesa telpu ar spilgtu Āzijas raksturu',

  // CTA Banner Section
  'ctaBanner.title': 'Nepalaidiet Garām Labu Vietu!',
  'ctaBanner.subtitle': 'Kiosku skaits Asian Alley ir ierobežots. Reģistrējieties šodien, lai saņemtu bezmaksas konsultāciju un izvēlētos labāko vietu.',
  'ctaBanner.price': 'Tikai no 10 EUR/dienā — Sāciet biznesu Eiropā tūlīt!',
  'ctaBanner.cta': 'Reģistrēties Tagad — Bezmaksas Konsultācija',
  'ctaBanner.phone': 'Zvaniet Tagad: +371 2572 6969',

  // Register Form Section
  'register.badge': 'Reģistrēties Tagad',
  'register.title.line1': 'Rezervēt Kiosku',
  'register.title.line2': 'Labākajā Vietā',
  'register.subtitle': 'Kiosku skaits ir ierobežots — reģistrējieties agri, lai izvēlētos labāko vietu Asian Alley. Mēs sazināsimies ar jums 24 stundu laikā bezmaksas konsultācijai.',
  'register.info.location.title': 'Atrašanās Vieta',
  'register.info.location.value': 'Krisjana Barona Iela 96/98, Rīga, Latvija',
  'register.info.hours.title': 'Darba Laiks',
  'register.info.hours.value': 'Pirmdiena – Svētdiena: 10:00 – 20:00',
  'register.info.hotline.title': 'Tālrunis',
  'register.info.hotline.value': '+371 2572 6969',
  'register.info.email.title': 'E-pasts',
  'register.info.email.value': 'contact@thedaeg.com',
  'register.promo.title': '🔥 Īpašais piedāvājums',
  'register.promo.desc': 'Reģistrējieties šajā mēnesī — bezmaksas pirmā nedēļa un pilnīgi bezmaksas kioska iestatīšanas atbalsts!',
  'register.form.title': 'Aizpildiet Reģistrācijas Informāciju',
  'register.form.name': 'Vārds un Uzvārds',
  'register.form.namePlaceholder': 'Jānis Bērziņš',
  'register.form.phone': 'Tālruņa Numurs',
  'register.form.phonePlaceholder': '+84 vai +371...',
  'register.form.email': 'E-pasts',
  'register.form.emailPlaceholder': 'email@example.com',
  'register.form.kioskType': 'Interesējošais Kioska Veids',
  'register.form.kioskTypePlaceholder': '-- Izvēlieties kioska veidu --',
  'register.form.kioskGroup.daily': '📅 Īre pēc Dienas',
  'register.form.kioskGroup.monthly': '📆 Īre pēc Mēneša',
  'register.form.kioskMiniDaily': 'Mini Kiosks (1.7×2.5m) — 10 EUR/dienā',
  'register.form.kioskStandardDaily': 'Standarta Kiosks (2.5×2.5m) — 25 EUR/dienā',
  'register.form.kioskMiniMonthly': 'Mini Kiosks (1.7×2.5m) — 150 EUR/mēnesī',
  'register.form.kioskStandardMonthly': 'Standarta Kiosks (2.5×2.5m) — 250 EUR/mēnesī',
  'register.form.kioskOfficeRent': 'Biroja Telpa (no 20m²) — Sazināties par cenu',
  'register.form.product': 'Plānotās Preces / Pakalpojumi',
  'register.form.productPlaceholder': '-- Izvēlieties kategoriju --',
  'register.form.productCraft': 'Amatniecība',
  'register.form.productClothing': 'Apģērbs un audumi',
  'register.form.productJewelry': 'Rotaslietas un aksesuāri',
  'register.form.productKitchen': 'Virtuves piederumi',
  'register.form.productService': 'Pakalpojumi (matu griešana, nagu aprūpe...)',
  'register.form.productOther': 'Cits',
  'register.form.addonTitle': 'Biznesa Atbalsta Pakete (Pēc Izvēles)',
  'register.form.addonPlaceholder': '-- Izvēlieties atbalsta paketi --',
  'register.form.addonNone': 'Nav nepieciešama atbalsta pakete',
  'register.form.addonStarter': 'STARTER — 30 EUR/mēnesī (Sākuma Atbalsts)',
  'register.form.addonBusiness': 'BUSINESS — 60 EUR/mēnesī (Profesionāls Bizness)',
  'register.form.addonPremium': 'PREMIUM — 100 EUR/mēnesī (Visaptverošs Bizness)',
  'register.form.extrasTitle': 'Papildu Izvēles Pakalpojumi',
  'register.form.extrasSubtitle': 'Izvēlieties individuālos pakalpojumus, kas jūs interesē (var izvēlēties vairākus)',
  'register.form.extraSelfEmployed': 'Pašnodarbināta reģistrācija',
  'register.form.extraTaxFiling': 'Vienreizēja nodokļu deklarācija',
  'register.form.extraFacebook': 'Facebook reklāma',
  'register.form.extraKioskDesign': 'Kioska dizains',
  'register.form.extraKioskSign': 'Kioska izkārtne',
  'register.form.message': 'Papildu Piezīmes',
  'register.form.messagePlaceholder': 'Jūsu jautājumi vai īpašie pieprasījumi... (maksimums 500 rakstzīmes)',
  'register.form.messageLimit': '/500',
  'register.form.required': '*',
  'register.form.submit': '🏪 Reģistrēties Kioska Īrei Tagad',
  'register.form.submitting': 'Nosūta...',
  'register.success': '✅ Reģistrācija veiksmīga! Mēs sazināsimies ar jums 24 stundu laikā.',
  'register.error': '❌ Radās kļūda. Lūdzu, mēģiniet vēlreiz vai sazinieties tieši pa tālruni.',
  'register.note': 'Bezmaksas konsultācija — Bez saistībām — Atbilde 24 stundu laikā',

  // Page Meta
  'meta.title': 'Asian Alley — Īrēt Kiosku Āzijas Preču Tirdzniecībai Rīgā Latvijā | The Daeg International',
  'meta.description': 'Īrējiet kiosku Āzijas preču tirdzniecībai Asian Alley Mini Mall — Rīga, Latvija. Izmērs 1.7×2.5m līdz 2.5×2.5m, cena tikai no 20 EUR/dienā vai 250 EUR/mēnesī. Visaptverošs atbalsts dokumentos, valodā, darbībā.',
  'meta.keywords': 'asian alley, kioska īre rīga latvija, āzijas preču bizness eiropā, kiosks mini mall latvija, asian alley mini mall',
};